import { useState } from 'react';
import jsPDF from 'jspdf';

export default function TrainingPrograms() {
  const [selectedProgram, setSelectedProgram] = useState(0);

  const programs = [
    {
      id: 'aviation',
      title: 'Aviation Crew Medical Training',
      icon: 'ri-plane-line',
      duration: '1-2 Days dependant on Crew Size',
      level: 'Per Crew Size',
      certification: 'Medical Emergency Certification',
      image: 'https://public.readdy.ai/ai/img_res/bd0d51fb48dededbfaf7e49c84443289.jpg',
      description: 'Comprehensive emergency medical training specifically designed for aviation crews operating in high-altitude, confined environments where immediate medical response is critical.',
      modules: [
        'In-Flight Cardiac Emergency Response. CPR',
        'High-Altitude Medical Crisis Management and readiness. i.e Asthmatic attack, Seizures, Fainting, Managing Diabetes',
        'Confined Space Trauma Care (customized)',
        'Medical Equipment Operation and first aid kit assessment',
        'Crew Coordination Under Pressure',
        'Passenger Medical Assessment ABCDE approach',
        'Emergency Landing Medical Procedures and communication'
      ],
      outcomes: [
        'Medical emergency certification',
        'Confidence in managing in-flight medical emergencies',
        'Proficiency with medical equipment. AED, First AID kits, Glucometer machines',
        'Enhanced crew coordination and communication skills'
      ]
    },
    {
      id: 'maritime',
      title: 'Maritime Crew Medical Training',
      icon: 'ri-ship-line',
      duration: '1-2 Days',
      level: 'Advanced',
      certification: 'Maritime Medical Response Specialist',
      image: 'https://readdy.ai/api/search-image?query=professional-female-medical-instructor-wearing-white-branded-polo-shirt-teaching-CPR-techniques-to-yacht-crew-members-in-white-uniforms-on-luxury-superyacht-deck-hands-on-training-with-mannequin-crystal-clear-ocean-background-bright-daylight-professional-maritime-training-sophisticated-environment&width=900&height=600&seq=maritimetraining002&orientation=landscape',
      description: 'Elite medical readiness training for Yacht and superyacht crews and maritime professionals, covering offshore emergency response, evacuation coordination, and extended care scenarios.',
      modules: [
        'Offshore Medical Emergency Management i.e managing CPR',
        'Maritime Evacuation Coordination and medical communication skills',
        'Extended Care Protocols at Sea. Monitoring patient recuperation.',
        'Marine Environment Medical Challenges. Asthmatic attack, Seizures, Fainting, Managing Diabetes.',
        'On Board- Emergency Equipment',
        'Helicopter Evacuation Procedures for trauma and use of fixators.',
        'Sea Sickness and Motion Management and medication',
        'Remote Medical Consultation Protocols'
      ],
      outcomes: [
        'Maritime medical response certification',
        'Expertise in offshore emergency management',
        'Helicopter evacuation coordination skills',
        'Extended medical care capabilities',
        'Medical Readiness Certification to enable one work anywhere in this industry.'
      ]
    },
    {
      id: 'estate',
      title: 'Estate Staff Medical Training',
      icon: 'ri-home-4-line',
      duration: '1-2 Days (Depends on size of estate staff)',
      level: 'Intermediate to Advanced',
      certification: 'Estate Medical Response Professional',
      image: 'https://readdy.ai/api/search-image?query=diverse-estate-staff-members-learning-AED-operation-and-emergency-response-with-professional-medical-instructor-in-elegant-luxury-private-residence-sophisticated-interior-high-end-estate-environment-focused-training-session-professional-medical-equipment-well-lit-training-area&width=900&height=600&seq=estatetraining003&orientation=landscape',
      description: 'Discreet, high-caliber emergency medical training for household staff, estate managers, and residential security teams serving UHNW families and principals.',
      modules: [
        'Residential Emergency Response',
        'Discreet Medical Crisis Management',
        'AED and CPR Certification',
        'Pediatric Emergency Care',
        'Elderly Care Medical Protocols',
        'Estate-Wide Emergency Coordination',
        'Medical Privacy and Discretion',
        'Family Medical History Management'
      ],
      outcomes: [
        'Estate medical response certification',
        'Discreet emergency management skills',
        'Pediatric and elderly care proficiency',
        'Coordinated estate-wide response capability'
      ]
    },
    {
      id: 'security',
      title: 'Security Team Medical Training',
      icon: 'ri-shield-user-line',
      duration: '1-2 Days',
      level: 'Advanced Tactical',
      certification: 'Tactical Medical Response Operator',
      image: 'https://readdy.ai/api/search-image?query=professional-medical-trainers-wearing-white-shirts-teaching-emergency-response-to-security-professionals-in-dark-suits-tactical-medical-training-facility-modern-environment-hands-on-demonstration-focused-atmosphere-professional-instructors-security-team-training&width=900&height=600&seq=securitytraining004&orientation=landscape',
      description: 'Tactical medical response training integrated with executive protection protocols, designed for security professionals.',
      modules: [
        'Executive Protection During a Medical Emergency. i.e Cardiac Arrest, Choking management.',
        'Chemical and Biological Exposure Response',
        'Secure Medical Communication and coordination evacuation'
      ],
      outcomes: [
        'Tactical medical operator certification',
        'Integrated security-medical response skills'
      ]
    },
    {
      id: 'hospitality',
      title: 'Elite Hospitality Medical Training',
      icon: 'ri-hotel-line',
      duration: '1-2 Days (depending on the size)',
      level: 'Intermediate',
      certification: 'Luxury Hospitality Medical Readiness Certification',
      image: 'https://readdy.ai/api/search-image?query=luxury-hotel-staff-in-elegant-uniforms-receiving-VIP-guest-medical-emergency-training-from-professional-instructor-five-star-hotel-setting-sophisticated-training-environment-high-end-hospitality-medical-protocols-professional-atmosphere&width=900&height=600&seq=hospitalitytraining005&orientation=landscape',
      description: 'VIP guest medical security protocols for luxury hotel staff, resort teams, and high-end hospitality professionals serving discerning clientele.',
      modules: [
        'VIP Guest Medical Privacy',
        'Discreet Emergency Response (tailored)',
        'Luxury Environment Medical Protocols coordination and communication.',
        'Multi-Lingual Medical Communication.',
        'Guest Medical Assessment',
        'Hotel-Wide Emergency Coordination',
        'Medical Equipment/(s) Strategic Storage, Deployment and use.',
        'Guest Medical History knowledge to ensure their medical safety while maintaining their privacy.'
      ],
      outcomes: [
        'Luxury Hospitality Medical Readiness Certification',
        'VIP guest medical privacy expertise',
        'Discreet emergency response skills'
      ]
    },
    {
      id: 'custom',
      title: 'Custom Training Programs',
      subtitle: 'With Surgical Precision',
      icon: 'ri-settings-3-line',
      duration: 'Tailored',
      level: 'All Levels',
      certification: 'Customized Certification',
      image: 'https://readdy.ai/api/search-image?query=elite-medical-training-session-with-precision-instruments-professional-instructors-in-pristine-white-coats-working-with-diverse-specialized-team-ultra-modern-training-facility-surgical-precision-equipment-high-end-professional-environment-sophisticated-bespoke-medical-education-tailored-program-meticulous-attention-to-detail&width=900&height=600&seq=customtraining006surgical&orientation=landscape',
      description: 'Bespoke medical security training programs engineered with surgical precision for your unique operational environment. Every protocol, every scenario, every skill module is meticulously crafted to address your specific risk profile, team composition, and operational requirements with exacting detail.',
      modules: [
        'Precision Risk Assessment & Threat Modeling',
        'Environment-Specific Protocol Engineering',
        'Tailored Scenario Training with Exact Replication',
        'Team-Specific Skill Development & Optimization',
        'Seamless Operational Integration',
        'Custom Equipment Training & Mastery',
        'Specialized Medical Protocols with Clinical Precision',
        'Ongoing Support, Recertification & Performance Refinement'
      ],
      outcomes: [
        'Fully customized certification program designed with surgical precision',
        'Environment-specific medical expertise tailored to exact operational needs',
        'Integrated operational protocols with seamless execution',
        'Ongoing training, support, and continuous performance optimization'
      ]
    }
  ];

  const downloadBrochure = async (program: typeof programs[0]) => {
    try {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 15;
      const contentWidth = pageWidth - (margin * 2);
      let yPosition = margin;

      // Load and add the training image
      const img = new Image();
      img.crossOrigin = 'anonymous';
      
      await new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
        img.src = program.image;
      });

      // Add image at top - reduced height
      const imgHeight = 50;
      pdf.addImage(img, 'JPEG', margin, yPosition, contentWidth, imgHeight);
      yPosition += imgHeight + 8;

      // Brand header
      pdf.setFontSize(8);
      pdf.setTextColor(180, 180, 180);
      pdf.text('U FIRST DOCTORS ELITE', margin, yPosition);
      yPosition += 6;

      // Program title - reduced size
      pdf.setFontSize(16);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont('helvetica', 'bold');
      const titleLines = pdf.splitTextToSize(program.title, contentWidth);
      pdf.text(titleLines, margin, yPosition);
      yPosition += titleLines.length * 6 + 4;

      // Program details box - compact
      pdf.setFillColor(245, 245, 245);
      pdf.rect(margin, yPosition, contentWidth, 18, 'F');
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(60, 60, 60);
      pdf.text(`Duration: ${program.duration}`, margin + 3, yPosition + 5);
      pdf.text(`Level: ${program.level}`, margin + 3, yPosition + 10);
      pdf.text(`Certification: ${program.certification}`, margin + 3, yPosition + 15);
      yPosition += 22;

      // Description - compact
      pdf.setFontSize(8);
      pdf.setTextColor(80, 80, 80);
      const descLines = pdf.splitTextToSize(program.description, contentWidth);
      const maxDescLines = 3;
      const displayDescLines = descLines.slice(0, maxDescLines);
      pdf.text(displayDescLines, margin, yPosition);
      yPosition += displayDescLines.length * 4 + 6;

      // Training Modules section - compact
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 0, 0);
      pdf.text('Training Modules', margin, yPosition);
      yPosition += 5;

      pdf.setFontSize(7);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(60, 60, 60);
      
      const maxModules = 8;
      const displayModules = program.modules.slice(0, maxModules);
      displayModules.forEach((module, index) => {
        const moduleText = `${index + 1}. ${module}`;
        const moduleLines = pdf.splitTextToSize(moduleText, contentWidth - 3);
        const displayLine = moduleLines[0];
        pdf.text(displayLine, margin + 2, yPosition);
        yPosition += 4;
      });

      yPosition += 4;

      // Learning Outcomes section - compact
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 0, 0);
      pdf.text('Learning Outcomes', margin, yPosition);
      yPosition += 5;

      pdf.setFontSize(7);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(60, 60, 60);
      
      const maxOutcomes = 4;
      const displayOutcomes = program.outcomes.slice(0, maxOutcomes);
      displayOutcomes.forEach((outcome) => {
        const outcomeText = `• ${outcome}`;
        const outcomeLines = pdf.splitTextToSize(outcomeText, contentWidth - 3);
        const displayLine = outcomeLines[0];
        pdf.text(displayLine, margin + 2, yPosition);
        yPosition += 4;
      });

      yPosition += 6;

      // Certification box - compact
      pdf.setFillColor(212, 196, 176);
      pdf.rect(margin, yPosition, contentWidth, 15, 'F');
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 0, 0);
      pdf.text('Certification Upon Completion', margin + 3, yPosition + 6);
      pdf.setFontSize(7);
      pdf.setFont('helvetica', 'normal');
      pdf.text(program.certification, margin + 3, yPosition + 11);
      yPosition += 18;

      // Footer section - compact
      pdf.setDrawColor(200, 200, 200);
      pdf.line(margin, yPosition, pageWidth - margin, yPosition);
      yPosition += 5;

      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 0, 0);
      pdf.text('Contact Us', margin, yPosition);
      yPosition += 5;

      pdf.setFontSize(7);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(80, 80, 80);
      pdf.text('Email: concierge@ufirstdoctorselite.com', margin, yPosition);
      yPosition += 4;
      pdf.text('Website: www.ufirstdoctorselite.com', margin, yPosition);

      // Save the PDF
      pdf.save(`${program.id}-training-brochure.pdf`);
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('There was an error generating the brochure. Please try again.');
    }
  };

  const downloadCertificatePreview = async (program: typeof programs[0]) => {
    try {
      const pdf = new jsPDF('l', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Certificate border
      pdf.setDrawColor(212, 196, 176);
      pdf.setLineWidth(3);
      pdf.rect(15, 15, pageWidth - 30, pageHeight - 30);
      
      pdf.setLineWidth(1);
      pdf.rect(20, 20, pageWidth - 40, pageHeight - 40);

      // Header
      pdf.setFontSize(10);
      pdf.setTextColor(100, 100, 100);
      pdf.setFont('helvetica', 'normal');
      pdf.text('U FIRST DOCTORS ELITE', pageWidth / 2, 35, { align: 'center' });

      // Certificate title
      pdf.setFontSize(28);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont('helvetica', 'bold');
      pdf.text('CERTIFICATE OF COMPLETION', pageWidth / 2, 55, { align: 'center' });

      // Decorative line
      pdf.setDrawColor(212, 196, 176);
      pdf.setLineWidth(0.5);
      pdf.line(80, 62, pageWidth - 80, 62);

      // This certifies text
      pdf.setFontSize(12);
      pdf.setTextColor(80, 80, 80);
      pdf.setFont('helvetica', 'normal');
      pdf.text('This is to certify that', pageWidth / 2, 80, { align: 'center' });

      // Participant name placeholder
      pdf.setFontSize(20);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont('helvetica', 'bold');
      pdf.text('[PARTICIPANT NAME]', pageWidth / 2, 95, { align: 'center' });
      
      // Underline for name
      pdf.setDrawColor(200, 200, 200);
      pdf.line(80, 97, pageWidth - 80, 97);

      // Has successfully completed
      pdf.setFontSize(12);
      pdf.setTextColor(80, 80, 80);
      pdf.setFont('helvetica', 'normal');
      pdf.text('has successfully completed', pageWidth / 2, 110, { align: 'center' });

      // Program name - Changed to Medical Emergency Readiness Training
      pdf.setFontSize(16);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Medical Emergency Readiness Training', pageWidth / 2, 125, { align: 'center' });

      // Certification type
      pdf.setFontSize(11);
      pdf.setTextColor(100, 100, 100);
      pdf.setFont('helvetica', 'normal');
      pdf.text(program.certification, pageWidth / 2, 140, { align: 'center' });

      // Date and signature section
      const bottomY = pageHeight - 50;
      
      // Date
      pdf.setFontSize(10);
      pdf.setTextColor(60, 60, 60);
      pdf.text('Date: [DD/MM/YYYY]', 60, bottomY);
      pdf.line(50, bottomY + 2, 110, bottomY + 2);

      // Signature
      pdf.text('Authorized Signature', pageWidth - 110, bottomY);
      pdf.line(pageWidth - 120, bottomY + 2, pageWidth - 50, bottomY + 2);

      // Certificate seal/badge
      pdf.setFillColor(212, 196, 176);
      pdf.circle(pageWidth / 2, bottomY - 5, 15, 'F');
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(7);
      pdf.setFont('helvetica', 'bold');
      pdf.text('CERTIFIED', pageWidth / 2, bottomY - 8, { align: 'center' });
      pdf.text('MEDICAL', pageWidth / 2, bottomY - 2, { align: 'center' });
      pdf.text('TRAINING', pageWidth / 2, bottomY + 4, { align: 'center' });

      // Footer
      pdf.setFontSize(7);
      pdf.setTextColor(120, 120, 120);
      pdf.setFont('helvetica', 'normal');
      pdf.text('www.ufirstdoctorselite.com | concierge@ufirstdoctorselite.com', pageWidth / 2, pageHeight - 25, { align: 'center' });
      pdf.text('This is a preview certificate. Actual certificates will be personalized upon course completion.', pageWidth / 2, pageHeight - 20, { align: 'center' });

      // Save the PDF
      pdf.save(`${program.id}-certificate-preview.pdf`);
    } catch (error) {
      console.error('Error generating certificate preview:', error);
      alert('There was an error generating the certificate preview. Please try again.');
    }
  };

  const downloadBrochureAsImage = async (program: typeof programs[0]) => {
    try {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 15;
      const contentWidth = pageWidth - (margin * 2);
      let yPosition = margin;

      // Load and add the training image
      const img = new Image();
      img.crossOrigin = 'anonymous';
      
      await new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
        img.src = program.image;
      });

      // Add image at top
      const imgHeight = 50;
      pdf.addImage(img, 'JPEG', margin, yPosition, contentWidth, imgHeight);
      yPosition += imgHeight + 8;

      // Brand header
      pdf.setFontSize(8);
      pdf.setTextColor(180, 180, 180);
      pdf.text('U FIRST DOCTORS ELITE', margin, yPosition);
      yPosition += 6;

      // Program title
      pdf.setFontSize(16);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont('helvetica', 'bold');
      const titleLines = pdf.splitTextToSize(program.title, contentWidth);
      pdf.text(titleLines, margin, yPosition);
      yPosition += titleLines.length * 6 + 4;

      // Program details box
      pdf.setFillColor(245, 245, 245);
      pdf.rect(margin, yPosition, contentWidth, 18, 'F');
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(60, 60, 60);
      pdf.text(`Duration: ${program.duration}`, margin + 3, yPosition + 5);
      pdf.text(`Level: ${program.level}`, margin + 3, yPosition + 10);
      pdf.text(`Certification: ${program.certification}`, margin + 3, yPosition + 15);
      yPosition += 22;

      // Description
      pdf.setFontSize(8);
      pdf.setTextColor(80, 80, 80);
      const descLines = pdf.splitTextToSize(program.description, contentWidth);
      const maxDescLines = 3;
      const displayDescLines = descLines.slice(0, maxDescLines);
      pdf.text(displayDescLines, margin, yPosition);
      yPosition += displayDescLines.length * 4 + 6;

      // Training Modules section
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 0, 0);
      pdf.text('Training Modules', margin, yPosition);
      yPosition += 5;

      pdf.setFontSize(7);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(60, 60, 60);
      
      const maxModules = 8;
      const displayModules = program.modules.slice(0, maxModules);
      displayModules.forEach((module, index) => {
        const moduleText = `${index + 1}. ${module}`;
        const moduleLines = pdf.splitTextToSize(moduleText, contentWidth - 3);
        const displayLine = moduleLines[0];
        pdf.text(displayLine, margin + 2, yPosition);
        yPosition += 4;
      });

      yPosition += 4;

      // Learning Outcomes section
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 0, 0);
      pdf.text('Learning Outcomes', margin, yPosition);
      yPosition += 5;

      pdf.setFontSize(7);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(60, 60, 60);
      
      const maxOutcomes = 4;
      const displayOutcomes = program.outcomes.slice(0, maxOutcomes);
      displayOutcomes.forEach((outcome) => {
        const outcomeText = `• ${outcome}`;
        const outcomeLines = pdf.splitTextToSize(outcomeText, contentWidth - 3);
        const displayLine = outcomeLines[0];
        pdf.text(displayLine, margin + 2, yPosition);
        yPosition += 4;
      });

      yPosition += 6;

      // Certification box
      pdf.setFillColor(212, 196, 176);
      pdf.rect(margin, yPosition, contentWidth, 15, 'F');
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 0, 0);
      pdf.text('Certification Upon Completion', margin + 3, yPosition + 6);
      pdf.setFontSize(7);
      pdf.setFont('helvetica', 'normal');
      pdf.text(program.certification, margin + 3, yPosition + 11);
      yPosition += 18;

      // Footer section
      pdf.setDrawColor(200, 200, 200);
      pdf.line(margin, yPosition, pageWidth - margin, yPosition);
      yPosition += 5;

      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 0, 0);
      pdf.text('Contact Us', margin, yPosition);
      yPosition += 5;

      pdf.setFontSize(7);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(80, 80, 80);
      pdf.text('Email: concierge@ufirstdoctorselite.com', margin, yPosition);
      yPosition += 4;
      pdf.text('Website: www.ufirstdoctorselite.com', margin, yPosition);

      // Convert to image
      const imgData = pdf.output('dataurlstring');
      const link = document.createElement('a');
      link.href = imgData;
      link.download = `${program.id}-training-brochure.png`;
      link.click();
    } catch (error) {
      console.error('Error generating image:', error);
      alert('There was an error generating the image. Please try again.');
    }
  };

  const downloadCertificateAsImage = async (program: typeof programs[0]) => {
    try {
      const pdf = new jsPDF('l', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Certificate border
      pdf.setDrawColor(212, 196, 176);
      pdf.setLineWidth(3);
      pdf.rect(15, 15, pageWidth - 30, pageHeight - 30);
      
      pdf.setLineWidth(1);
      pdf.rect(20, 20, pageWidth - 40, pageHeight - 40);

      // Header
      pdf.setFontSize(10);
      pdf.setTextColor(100, 100, 100);
      pdf.setFont('helvetica', 'normal');
      pdf.text('U FIRST DOCTORS ELITE', pageWidth / 2, 35, { align: 'center' });

      // Certificate title
      pdf.setFontSize(28);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont('helvetica', 'bold');
      pdf.text('CERTIFICATE OF COMPLETION', pageWidth / 2, 55, { align: 'center' });

      // Decorative line
      pdf.setDrawColor(212, 196, 176);
      pdf.setLineWidth(0.5);
      pdf.line(80, 62, pageWidth - 80, 62);

      // This certifies text
      pdf.setFontSize(12);
      pdf.setTextColor(80, 80, 80);
      pdf.setFont('helvetica', 'normal');
      pdf.text('This is to certify that', pageWidth / 2, 80, { align: 'center' });

      // Participant name placeholder
      pdf.setFontSize(20);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont('helvetica', 'bold');
      pdf.text('[PARTICIPANT NAME]', pageWidth / 2, 95, { align: 'center' });
      
      // Underline for name
      pdf.setDrawColor(200, 200, 200);
      pdf.line(80, 97, pageWidth - 80, 97);

      // Has successfully completed
      pdf.setFontSize(12);
      pdf.setTextColor(80, 80, 80);
      pdf.setFont('helvetica', 'normal');
      pdf.text('has successfully completed', pageWidth / 2, 110, { align: 'center' });

      // Program name - Changed to Medical Emergency Readiness Training
      pdf.setFontSize(16);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Medical Emergency Readiness Training', pageWidth / 2, 125, { align: 'center' });

      // Certification type
      pdf.setFontSize(11);
      pdf.setTextColor(100, 100, 100);
      pdf.setFont('helvetica', 'normal');
      pdf.text(program.certification, pageWidth / 2, 140, { align: 'center' });

      // Date and signature section
      const bottomY = pageHeight - 50;
      
      // Date
      pdf.setFontSize(10);
      pdf.setTextColor(60, 60, 60);
      pdf.text('Date: [DD/MM/YYYY]', 60, bottomY);
      pdf.line(50, bottomY + 2, 110, bottomY + 2);

      // Signature
      pdf.text('Authorized Signature', pageWidth - 110, bottomY);
      pdf.line(pageWidth - 120, bottomY + 2, pageWidth - 50, bottomY + 2);

      // Certificate seal/badge
      pdf.setFillColor(212, 196, 176);
      pdf.circle(pageWidth / 2, bottomY - 5, 15, 'F');
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(7);
      pdf.setFont('helvetica', 'bold');
      pdf.text('CERTIFIED', pageWidth / 2, bottomY - 8, { align: 'center' });
      pdf.text('MEDICAL', pageWidth / 2, bottomY - 2, { align: 'center' });
      pdf.text('TRAINING', pageWidth / 2, bottomY + 4, { align: 'center' });

      // Footer
      pdf.setFontSize(7);
      pdf.setTextColor(120, 120, 120);
      pdf.setFont('helvetica', 'normal');
      pdf.text('www.ufirstdoctorselite.com | concierge@ufirstdoctorselite.com', pageWidth / 2, pageHeight - 25, { align: 'center' });
      pdf.text('This is a preview certificate. Actual certificates will be personalized upon course completion.', pageWidth / 2, pageHeight - 20, { align: 'center' });

      // Convert to image
      const imgData = pdf.output('dataurlstring');
      const link = document.createElement('a');
      link.href = imgData;
      link.download = `${program.id}-certificate-preview.png`;
      link.click();
    } catch (error) {
      console.error('Error generating certificate image:', error);
      alert('There was an error generating the certificate image. Please try again.');
    }
  };

  return (
    <section id="programs" className="bg-[#0D0D0D] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="text-[9px] uppercase tracking-[0.2em] text-[#707070] font-light mb-4">
            Training Excellence
          </div>
          <h2 className="text-[40px] sm:text-[48px] md:text-[56px] font-bold text-[#F5F5F5] mb-6 font-serif">
            Specialized Retainer Training Programs
          </h2>
          <p className="text-[16px] text-[#9A9A9A] max-w-[800px] mx-auto leading-relaxed">
            Each program is meticulously designed for specific operational environments, combining theoretical excellence with intensive practical application.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          <div className="lg:col-span-1 space-y-3">
            {programs.map((program, index) => (
              <button
                key={program.id}
                onClick={() => setSelectedProgram(index)}
                className={`w-full text-left p-6 rounded-xl transition-all duration-300 cursor-pointer ${
                  selectedProgram === index
                    ? 'bg-[#1A1815] border-2 border-[#D4C4B0]'
                    : 'bg-[#111111] border border-[#222222] hover:border-[#333333]'
                }`}
              >
                <div className="flex items-center gap-4">
                  <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                    selectedProgram === index ? 'bg-[#D4C4B0]' : 'bg-[#1A1A1A]'
                  }`}>
                    <i className={`${program.icon} text-[24px] ${
                      selectedProgram === index ? 'text-black' : 'text-[#D4C4B0]'
                    }`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className={`text-[16px] font-semibold mb-1 ${
                      selectedProgram === index ? 'text-[#F5F5F5]' : 'text-[#C0C0C0]'
                    }`}>
                      {program.title}
                    </h3>
                    {program.subtitle && (
                      <p className={`text-[11px] italic mb-1 ${
                        selectedProgram === index ? 'text-[#D4C4B0]' : 'text-[#808080]'
                      }`}>
                        {program.subtitle}
                      </p>
                    )}
                    <p className="text-[12px] text-[#808080]">{program.duration}</p>
                  </div>
                  <i className={`ri-arrow-right-line text-[20px] ${
                    selectedProgram === index ? 'text-[#D4C4B0]' : 'text-[#505050]'
                  }`}></i>
                </div>
              </button>
            ))}
          </div>

          <div className="lg:col-span-2">
            <div className="bg-[#0F0F0F] border border-[#1A1A1A] rounded-2xl overflow-hidden">
              <div className="relative h-[400px] w-full">
                <img 
                  src={programs[selectedProgram].image}
                  alt={programs[selectedProgram].title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <div className="flex items-center gap-3 mb-3">
                    <i className={`${programs[selectedProgram].icon} text-[32px] text-[#D4C4B0]`}></i>
                    <div>
                      <h3 className="text-[28px] font-bold text-white">{programs[selectedProgram].title}</h3>
                      {programs[selectedProgram].subtitle && (
                        <p className="text-[16px] italic text-[#D4C4B0] mt-1">{programs[selectedProgram].subtitle}</p>
                      )}
                    </div>
                  </div>
                  <div className="flex gap-4 text-[13px] text-[#C0C0C0]">
                    <span className="flex items-center gap-2">
                      <i className="ri-time-line"></i>
                      {programs[selectedProgram].duration}
                    </span>
                    <span className="flex items-center gap-2">
                      <i className="ri-bar-chart-line"></i>
                      {programs[selectedProgram].level}
                    </span>
                  </div>
                </div>
              </div>

              <div className="p-8">
                <p className="text-[15px] text-[#A0A0A0] leading-relaxed mb-8">
                  {programs[selectedProgram].description}
                </p>

                <div className="mb-8">
                  <h4 className="text-[18px] font-semibold text-[#F5F5F5] mb-4 flex items-center gap-2">
                    <i className="ri-file-list-3-line text-[#D4C4B0]"></i>
                    Training Modules
                  </h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {programs[selectedProgram].modules.map((module, index) => (
                      <div key={index} className="flex items-start gap-3 bg-[#111111] p-4 rounded-lg">
                        <div className="w-6 h-6 bg-[#1A1815] rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                          <span className="text-[11px] text-[#D4C4B0] font-semibold">{index + 1}</span>
                        </div>
                        <span className="text-[14px] text-[#C0C0C0]">{module}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mb-8">
                  <h4 className="text-[18px] font-semibold text-[#F5F5F5] mb-4 flex items-center gap-2">
                    <i className="ri-award-line text-[#D4C4B0]"></i>
                    Learning Outcomes
                  </h4>
                  <div className="space-y-3">
                    {programs[selectedProgram].outcomes.map((outcome, index) => (
                      <div key={index} className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-[#D4C4B0] text-[18px] mt-0.5"></i>
                        <span className="text-[14px] text-[#C0C0C0]">{outcome}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-[#111111] border border-[#222222] rounded-xl p-6 mb-8">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="text-[16px] font-semibold text-[#F5F5F5] mb-1">
                        {programs[selectedProgram].certification}
                      </h4>
                      <p className="text-[13px] text-[#808080]">Internationally recognized certification</p>
                    </div>
                    <i className="ri-medal-line text-[40px] text-[#D4C4B0]"></i>
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <a 
                    href="#contact" 
                    className="px-6 py-4 bg-[#D4C4B0] text-black text-[14px] font-semibold text-center rounded-lg hover:bg-[#C4B4A0] transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-calendar-check-line text-[18px]"></i>
                    Book Training Session
                  </a>
                  <button 
                    onClick={() => downloadCertificatePreview(programs[selectedProgram])}
                    className="px-6 py-4 bg-transparent border border-[#333333] text-[#C0C0C0] text-[14px] font-semibold rounded-lg hover:border-[#D4C4B0] hover:text-[#D4C4B0] transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-award-line text-[18px]"></i>
                    Preview Certificate
                  </button>
                  <button 
                    onClick={() => downloadBrochure(programs[selectedProgram])}
                    className="px-6 py-4 bg-transparent border border-[#333333] text-[#C0C0C0] text-[14px] font-semibold rounded-lg hover:border-[#D4C4B0] hover:text-[#D4C4B0] transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-download-line text-[18px]"></i>
                    Download PDF
                  </button>
                  <button 
                    onClick={() => downloadBrochureAsImage(programs[selectedProgram])}
                    className="px-6 py-4 bg-transparent border border-[#333333] text-[#C0C0C0] text-[14px] font-semibold rounded-lg hover:border-[#D4C4B0] hover:text-[#D4C4B0] transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    <i className="ri-image-line text-[18px]"></i>
                    Save as Image
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
